export default __webpack_public_path__ + "static/media/SquareRed.4b934db8.svg";